export default __webpack_public_path__ + "static/media/spain-flag.f4fc887f.png";